import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Paper, Chip, Stack, Avatar, CircularProgress } from '@mui/material';
import { grey } from '@mui/material/colors';
import AddIcon from '@mui/icons-material/Add';
import PlumbingOutlinedIcon from '@mui/icons-material/PlumbingOutlined';

import Newsystem from './Newsystem';
import Deletesystem from './Deletesystem'; 
import Editsystem from './Editsystem'; 

import BASE_URL from '../../config';

export default function PaginaEquipo() {
  const [equipos, setequipos] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [expandedRows, setExpandedRows] = useState({});

  const fetchEquipos = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/equipos/todo`);
      const data = await res.json();
      setequipos(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error("Error:", e);
      setequipos([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchEquipos(); }, []);

  // Función para alternar la visibilidad de los chips
  const toggleExpand = (id) => {
    setExpandedRows(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  return (
    <Box>
      {/* HEADER */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between',flexDirection:{xs:'column',md:'row'}, alignItems: {xs:'flex-start',md:'center'},gap:2, mb: 3 }}>
        <Box>
          <Typography variant='h6' fontWeight="bold">Equipos y Soluciones</Typography>
          <Typography variant='body1' color='textSecondary'>Gestiona el catálogo de equipos y soluciones</Typography>
        </Box>
        <Box sx={{width:{xs:'100%',sm:'auto'}}}>
          <Button 
            fullWidth
            variant="contained" 
            disableElevation
            sx={{ bgcolor: 'black', textTransform: 'none', borderRadius: 2, px: 3 }} 
            onClick={() => setOpenModal(true)}
            startIcon={<AddIcon/>}
          >
            Nuevo Equipo
          </Button>
        </Box>
      </Box>

      {/* CONTENEDOR GRID FLEXIBLE */}
      {loading ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 10 }}>
          <CircularProgress size={40} sx={{ color: 'grey.500' }} />
          <Typography sx={{ mt: 2, color: 'grey.600' }}>Cargando equipos...</Typography>
        </Box>
      ) : (
      <Box sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
        gap: 2
      }}>
        {equipos.map((rowe) => {
          const isExpanded = expandedRows[rowe.id];
          const tiposArray = Array.isArray(rowe.tipo) ? rowe.tipo : [];
          // Si está expandido mostramos todo, si no, solo los primeros 2
          const tiposAMostrar = isExpanded ? tiposArray : tiposArray.slice(0, 2);

          return (
            <Paper 
              key={rowe.id}
              elevation={0}
              sx={{ 
                p: 2, 
                border: `1px solid ${grey[200]}`, 
                borderRadius: 3,
                aspectRatio: '1/0.6',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                transition: 'all 0.2s',
                '&:hover': { 
                  borderColor: grey[400],
                  transform: 'translateY(-4px)',
                  boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
                }
              }}
            >
              {/* CABECERA DE LA CARD */}
              <Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                  <Avatar sx={{ bgcolor: grey[100], color: grey[800], borderRadius: 2, width: 42, height: 42 }}>
                    <PlumbingOutlinedIcon fontSize="medium" />
                  </Avatar>
                  <Typography variant="h6" noWrap mx={2} sx={{ mb: 0.5 }}>
                    {rowe.nombre}
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 0.5 }}>
                    <Editsystem equipo={rowe} refresh={fetchEquipos} />
                    <Deletesystem equipo={rowe} refresh={fetchEquipos} />
                  </Box>
                </Box>
                
                <Typography variant='body1' color="textSecondary" sx={{ 
                  overflow: 'hidden',
                  mb: 2
                }}>
                  {rowe.descripcion || 'Sin descripción...'}
                </Typography>
              </Box>

              {/* PIE DE LA CARD (CHIPS Y CONTROL DE EXPANSIÓN) */}
              <Box>
                <Stack direction="row" spacing={1.2} flexWrap="wrap" useFlexGap>
                  {tiposAMostrar.map((t, i) => (
                    <Chip 
                      key={i} 
                      label={t} 
                      size="small" 
                      sx={{  
                        bgcolor: grey[200], 
                        color:'black',
                      }} 
                    />
                  ))}

                  {/* Mostrar contador +N si hay más elementos y no está expandido */}
                  {!isExpanded && tiposArray.length > 3 && (
                    <Chip  
                      variant="caption" 
                      size="small" 
                      onClick={() => toggleExpand(rowe.id)}
                      clickable
                      label={`+ ${tiposArray.length-2}`} 
                      sx={{ 
                        px:1, 
                        transition: 'all 0.3s ease',
                        color:'white',
                        bgcolor:'black',
                        ":hover":{bgcolor:grey[700]}
                      }} 
                    />
                  )}

                  {/* Mostrar "Ver menos" solo cuando la tarjeta está expandida */}
                  {isExpanded && tiposArray.length > 3 && (
                    <Chip  
                      variant="caption" 
                      clickable
                      size="small" 
                      onClick={() => toggleExpand(rowe.id)}
                      label={"Ver menos"}
                      sx={{ 
                        px:1, 
                        transition: 'all 0.3s ease',
                        color:'white',
                        bgcolor:'black',
                        ":hover":{bgcolor:grey[700]}
                      }} 
                    >
                    </Chip >
                  )}
                </Stack>
              </Box>
            </Paper>
          );
        })}
      </Box>
      )}

      <Newsystem 
        open={openModal} 
        handleClose={() => setOpenModal(false)} 
        refreshEquipos={fetchEquipos} 
      />
    </Box>
  );
}